<template>
    <el-row v-loading="loading">
        <el-col :span="24">
            <div style="text-align: left;">
                <el-button type="text" icon="el-icon-back" @click="goBack" style="padding-bottom: 0px;">返回</el-button>
                <el-button type="primary" @click="handleEditor" style="margin-left: 20px">重新编辑</el-button>
            </div>
        </el-col>
        <el-col :span="24">
            <div>
                <div>
                    <h3 style="margin-top: 0px;margin-bottom: 0px">
                        {{ article.title }}
                    </h3>
                </div>
                <div style="width: 100%;margin-top: 5px;display: flex;justify-content: flex-end;align-items: center">
                    <div style="display: inline; color: #20a0ff;margin-left: 50px;margin-right:20px;font-size: 12px;">
                        {{ article.nickname }}
                    </div>
                    <!-- <span
                        style="color: #20a0ff;margin-right:20px;font-size: 12px;"
                        >浏览
                        {{
                            article.pageView == null ? 0 : article.pageView
                        }}</span
                    > -->
                    <span style="color: #20a0ff;margin-right:20px;font-size: 12px;"> {{ article.publishDate | formatDateTime }}</span>

                    <span style="color: #20a0ff;margin-right:20px;font-size: 12px;"> 所属分类:{{ article.cateName }}</span>
                    <span style="margin:0px 50px 0px 0px"></span>
                </div>
            </div>
        </el-col>
        <el-col>
            <div style="text-align: left" v-html="article.htmlContent"></div>
        </el-col>
    </el-row>
</template>
<script>
import { getRequest, postRequest } from '@/utils/api';
export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getPorductDetail(lid) {
            this.loading = true;
            postRequest('/productDetail/find', { lid })
                .then(result => {
                    this.loading = false;
                    const { code, message, data } = result.data;
                    if (code === 200) {
                        this.article = data;
                        this.$message({ type: 'success', message: message });
                    } else {
                        this.$message({
                            type: 'error',
                            message: '页面加载失败!',
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'error',
                        message: '检查网络错误或服务器是否响应!',
                    });
                });
        },
        handleEditor() {
            this.$confirm('产品参数已存在,是否重新编辑？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                console.log('确定');
                this.$router.push({
                    path: '/editProductDetail',
                    query: { lid: this.lid, pid: this.pid, isStatus: 1 },
                });
            });
        },
    },
    mounted: function() {
        const { lid, pid } = this.$route.query;
        if (lid && pid) {
            this.lid = lid;
            this.pid = pid;
            this.getPorductDetail(lid);
        } else {
            this.goBack();
        }
    },
    data() {
        return {
            article: {},
            loading: false,
            activeName: '',
            lid: '',
            pid: '',
        };
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/product/productDetail.vue